import PlansComponent from "../app/store/Plans"
import Menu from "./Menu"
import Styles from '../../styles/Home.module.css'
import { useEffect } from "react"

export default function Plans() {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return <>
        <Menu />
        <div className={Styles.secondaryContainer}>
            <PlansComponent />
        </div>
    </>
}